import React from "react";


const ScreeningOverview = () => {
    return (
        <div className="row">
            ScreeningOverview
        </div>
    )
}

export default ScreeningOverview;